<template>
     <div class="warp">
        <Nav ref="navRef" :btnList="btnList"></Nav>
        <div style="width:100vw">
            <router-view></router-view>
        </div>
        <Bottom></Bottom>
     </div>
</template>
<script>
import Bottom from '@/components/bottom.vue'
// 导航
import Nav from '@/components/nav.vue'
export default {
    components:{
        Bottom,
        Nav,
    },
    data:()=>({
        btnList:[]
    }),
    mounted(){

    },
    methods:{ 
        setBtnList(btnList){ 
            this.btnList = btnList;
        }
    }
}
</script>
<style scoped>
    .warp{
       /* padding-top:60px;  */
    }
</style>